<template>
  <BaseDataIterator ref="dataList" :service="fetchData">
    <template #default="{ data }">
      <BaseDataTable :data="data">
        <template #header>
          <UserListListHeader />
        </template>

        <template #default="{ item }">
          <UserListListItem :key="item.id" :ga-user-list="item" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { googleAdsUserListsClient } from '@/api/clients/admin';
import UserListListHeader from './UserListListHeader.vue';
import UserListListItem from './UserListListItem.vue';

export default {
  components: {
    UserListListHeader,
    UserListListItem,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    async fetchData(params = {}) {
      try {
        const response = await googleAdsUserListsClient.list({
          ...params,
          include: 'gaCustomer',
        });

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
